import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Layout from '../../components/Layout/Layout';
import { DefaultButton, SubTitleH2, ResetPassword } from '../../components';
import { requestSignOut } from '../../actions/auth';

class Profile extends Component {
  constructor() {
    super();
    this.state = {};
  }

  signOut = () => {
    const { dispatch } = this.props;
    dispatch(requestSignOut());
  };

  resetPassword = pass => {
    const { accessToken, dispatch } = this.props;
    dispatch({ token: accessToken, password: pass });
  };

  render() {
    const { user } = this.props;
    return (
      <Layout>
        <Container fluid>
          <Row>
            <Col role="main">
              <div className="section">
                <Row>
                  <Col>
                    <SubTitleH2 text="Mi Perfil" />
                  </Col>
                  <Row>
                    <Col className="d-none d-md-block">
                      <div className="d-flex gap-2">
                        <ResetPassword />
                        <DefaultButton
                          variant="outline-info"
                          text="Cerrar Sesión"
                          onClick={this.signOut}
                        />
                      </div>
                    </Col>
                  </Row>
                </Row>
                <Row>
                  <Col>
                    <p>
                      <strong>Usuario:</strong> {user.name}
                    </p>
                    <p>
                      <strong>RUT:</strong> {user.rut}
                    </p>
                    <p>
                      <strong>Correo:</strong> {user.email}
                    </p>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
          <Row>
            <Col className="d-flex d-md-none justify-content-between">
              <ResetPassword />
              <DefaultButton
                variant="outline-info"
                text="Cerrar Sesión"
                onClick={this.signOut}
              />
            </Col>
          </Row>
        </Container>
      </Layout>
    );
  }
}

const mapStateToProps = state => {
  const {
    ongoingRequest,
    signedIn,
    headers: { accessToken },
    user
  } = state.auth;
  return {
    ongoingRequest,
    signedIn,
    accessToken,
    user
  };
};

export default withRouter(connect(mapStateToProps)(Profile));
